import { useEffect } from 'react';

const BASE_TITLE = 'QCMAntitriche';

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE_TITLE}` : `${BASE_TITLE} | Créez, imprimez et corrigez vos QCM`;
    return () => { document.title = `${BASE_TITLE} | Créez, imprimez et corrigez vos QCM`; };
  }, [title]);
}
